import { Component, Input, Output, EventEmitter, Renderer2, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { ImageCacheService } from 'src/app/services/image-cache.service';
import { EventCard } from 'src/interfaces/event-card.model';

@Component({
    selector: 'app-menu-event-card',
    templateUrl: './menu-event-card.component.html',
    styleUrls: ['./menu-event-card.component.css'],
    standalone: false
})
export class MenuEventCardComponent {
  constructor(
    private imageCache: ImageCacheService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {}

  @Input() card!: EventCard;
  @Input() width!: number;
  @Input() height!: number;
  @Output() clickCard = new EventEmitter<string>();

  showImage: boolean = false;

  /**
   * Оверлей — сразу в body: карточка лежит в горизонтальной ленте событий
   * (overflow-x: auto), и Safari на iOS обрезает position: fixed по её
   * границам. При закрытии *ngIf удаляет узел из body сам
   */
  @ViewChild('overlay') set overlay(ref: ElementRef<HTMLElement> | undefined) {
    if (ref) this.renderer.appendChild(document.body, ref.nativeElement);
  }

  // Изображение заглушка
  imageSrc: string | null = null;

  ngOnInit(): void {
    // Image
    if (this.card?.image?.trim()) {
      this.imageCache.getImage(this.card.image).then(src => {
        this.imageSrc = src;
      });
    }
  } 

  onClick(event: Event): void {
    event.stopPropagation();
    this.showImage = true;
    this.renderer.addClass(document.body, 'no-scroll');
  }

  onClose(event: Event): void {
    event.stopPropagation();
    this.showImage = false;
    this.renderer.removeClass(document.body, 'no-scroll');
  }
}